import "react-app-polyfill/ie9";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { ThemeProvider } from "styled-components";
import App from "./components/App";
import ErrorBoundary from "./components/ErrorBoundary";
import history from "./history";
import store from "./store";
import { initMonitoring } from "./monitoring";
import removeLandingShell from "./lib/landingShell";
import { prefetchEldoradoBridge } from "./lib/eldoradoLoader";

import { STYLES, GlobalFonts, GlobalStyle } from "./styles/_utilities";
import "./index.scss";

initMonitoring();

// O shell estático da landing não pode sobreviver a uma navegação (ex.: redirect antes da landing montar).
history.listen(removeLandingShell);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={STYLES}>
      <ErrorBoundary>
        <App history={history} />
      </ErrorBoundary>
      <GlobalFonts />
      <GlobalStyle />
    </ThemeProvider>
  </Provider>,
  document.getElementById("app-root")
);

prefetchEldoradoBridge();
